const size = {
  mobileS: `330px`,
  mobileM: `400px`,
  mobileL: `480px`,
  tabletS: `600px`,
  tabletL: `768px`,
  desktopXS: `900px`,
  desktopS: `1080px`,
  desktopM: `1200px`,
  desktopL: `1400px`,
};

export const device = {
  mobileS: `(max-width: ${size.mobileS})`,
  mobileM: `(max-width: ${size.mobileM})`,
  mobileL: `(max-width: ${size.mobileL})`,
  mdS: `(max-width: ${size.tabletS})`,
  mdM: `(max-width: ${size.tabletL})`,
  mdL: `(max-width: ${size.desktopXS})`,
  lg: `(max-width: ${size.desktopS})`,
  xl: `(max-width: ${size.desktopM})`,
  xxl: `(max-width: ${size.desktopL})`,
};
